import { gql } from '@apollo/client';

export const QUERY_USER_ONG = gql`
  query GetUserOng($userId: ID!) {
    usersPermissionsUser(id: $userId) {
      data {
        id
        attributes {
          ong
        }
      }
    }
  }
`;
